import React, { useState } from "react";
import Modal from "@mui/material/Modal";
import { Box } from "@mui/material";
import XCloseIcon from "assets/icons/HeroIcons/XCloseIcon";
import { RootState } from "store";
import { useSelector } from "react-redux";
import {
  closeArchiveOrPublishOrganizationModalAction,
  closeOrganizationsProfileDetailModalAction,
} from "store/modals/reducer.actions";
import { useDispatch } from "react-redux";
import apiLibrary from "services/api";
import { Toasts } from "view/components/Toasts";
import Button from "view/components/Button";
import { organizationsStatusAction } from "store/filters/reducer.actions";
import { ThunkDispatch } from "redux-thunk";
import { AnyAction } from "redux";
import { fetchOrganizationProfileAction } from "store/organizationProfile/reducer.actions";
import { useParams } from "react-router-dom";
import { fetchOrganizationsAction } from "store/oranizations";
const style: React.CSSProperties = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  borderRadius: "10px",
  backgroundColor: "#ffff",
};

interface ArchiveOrPublishOrganizationModalProps { }

export const ArchiveOrPublishOrganizationModal: React.FC<
  ArchiveOrPublishOrganizationModalProps
> = () => {
  const { archiveOrPublishOrganizationModal } = useSelector(
    (state: RootState) => state.modals
  );
  const { organizationId, communityId, programId } = useParams();
  const dispatch: ThunkDispatch<any, any, AnyAction> = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const handleClose = () => {
    dispatch(closeArchiveOrPublishOrganizationModalAction());
  };
  const archiveOrPublishOrganization = async () => {
    try {
      setIsLoading(true);
      const res = await apiLibrary.OrganizationDirectory.archiveOrganization(
        archiveOrPublishOrganizationModal.data.id,
        archiveOrPublishOrganizationModal?.data?.status === "archived"
          ? "active"
          : "archived"
      );
      if (archiveOrPublishOrganizationModal.data.profilePage) {
        dispatch(fetchOrganizationProfileAction(organizationId));
        Toasts.success(res.message);
      } else {
        dispatch(fetchOrganizationsAction(communityId, programId));
        dispatch(
          organizationsStatusAction(
            archiveOrPublishOrganizationModal?.data?.status === "archived"
              ? "active"
              : "archived"
          )
        );
      }

      dispatch(closeOrganizationsProfileDetailModalAction());
      handleClose();
    } catch (error: any) {
      const errorMsg = error?.response?.data?.message ?? error?.message;
      Toasts.error(errorMsg);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      open={archiveOrPublishOrganizationModal?.isOpen}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      disableAutoFocus={true}
      aria-describedby="modal-modal-description"
      className="border-none"
    >
      <Box sx={style} className="dark:bg-secondaryLight ">
        <div className="flex flex-col justify-start items-start w-[480px] rounded-lg">
          <div
            className="relative flex flex-col items-start self-stretch justify-start flex-grow-0 flex-shrink-0 gap-4 p-6 rounded-lg bg-bgWhite dark:bg-secondaryLight"
            style={{
              boxShadow:
                "0px 2px 8px 0 rgba(2,13,36,0.1), 0px 2px 24px 0 rgba(2,13,36,0.08)",
            }}
          >
            <div className="flex  justify-between items-start self-stretch flex-grow-0 flex-shrink-0 py-0.5">
              <div className="relative flex items-center self-stretch justify-start flex-grow-0 flex-shrink-0">
                <p className="flex-grow text-xl font-semibold text-left text-textMid dark:text-textMain">
                  {archiveOrPublishOrganizationModal?.data?.status === "active"
                    ? "Archive Organization"
                    : "Restore Organization"}
                </p>
              </div>
              <button onClick={handleClose} type="button">
                <XCloseIcon width={24} height={24} viewBox="0 0 24 24" />
              </button>
            </div>
            {archiveOrPublishOrganizationModal.data?.brandConnected ?

              <div className="flex justify-start items-start self-stretch flex-grow-0 flex-shrink-0 relative gap-2 pb-1.5">
                <p className="flex-grow w-[432px] text-sm text-left text-textMid  dark:text-textMain">
                  You cannot archive this Organization because it is the owner of a brand. If you do want to archive the Organization, make sure to archive the brand first. When the brand is archived you will be able to archive the Organization as well.
                </p>
              </div>
              :
              <div className="flex justify-start items-start self-stretch flex-grow-0 flex-shrink-0 relative gap-2 pb-1.5">
                {archiveOrPublishOrganizationModal?.data?.status === "active" ? (
                  <p className="flex-grow w-[432px] text-sm text-left text-textMid  dark:text-textMain">
                    Are you sure that you want to Archive this Organization? An
                    organization can always be restored from the archived tab.
                  </p>
                ) : (
                  <p className="flex-grow w-[432px] text-sm text-left text-textMid  dark:text-textMain">
                    Are you sure that you want to Publish this organization? This
                    means the organization will be visible for observers.
                  </p>
                )}
              </div>}

            {!archiveOrPublishOrganizationModal.data?.brandConnected &&
              <div className="flex items-center self-stretch justify-end flex-grow-0 flex-shrink-0 gap-2">
                <Button
                  type="button"
                  text="Cancel"
                  filledColor="primary"
                  outlinedColor="primary"
                  textColor="textWhite"
                  className="px-5 py-2"
                  width="35"
                  height="13"
                  fontStyle="font-semibold"
                  variant="outlined"
                  onClick={handleClose}
                />

                <Button
                  disabled={isLoading}
                  type="button"
                  text={
                    archiveOrPublishOrganizationModal?.data?.status === "active"
                      ? "Archive"
                      : "Restore"
                  }
                  filledColor="primary"
                  outlinedColor="primary"
                  textColor="textWhite"
                  className="px-5 py-2"
                  width="35"
                  height="13"
                  fontStyle="font-semibold"
                  variant="filled"
                  onClick={archiveOrPublishOrganization}
                />
              </div>}
          </div>
        </div>
      </Box>
    </Modal>
  );
};
